import { PlayCircle } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import DemoBanner from '~/pages/help/demo/DemoBanner'

/** Ce qui tient la place du package dans les démonstrations du lecteur (#105). */
function DemoModuleContent({ backTo }: { backTo: string }) {
  const { t } = useTranslation()

  return (
    <div className="flex h-full flex-col p-4 sm:p-6">
      <DemoBanner backTo={backTo} />
      <div className="flex flex-1 flex-col items-center justify-center gap-3 rounded-2xl border border-dashed border-border text-center text-muted-foreground">
        <PlayCircle className="size-10" />
        <p className="max-w-sm text-sm">{t('helpDemo.player.placeholder')}</p>
      </div>
    </div>
  )
}

export default DemoModuleContent
